import script from "./ReturningArea.vue?vue&type=script&setup=true&lang=js"
export * from "./ReturningArea.vue?vue&type=script&setup=true&lang=js"

import "./ReturningArea.vue?vue&type=style&index=0&id=f904f630&scoped=true&lang=scss"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f904f630"]])

export default __exports__